<template>
  <VueDatePicker
    ref="picker"
    v-bind="$attrs"
    :locale="effectiveLocale"
    :action-row="effectiveActionRow"
  />
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { de, enUS, fr } from 'date-fns/locale';
import type { Locale } from 'date-fns';

defineOptions({ inheritAttrs: false });

type ActionRowConfig = {
  selectBtnLabel?: string;
  cancelBtnLabel?: string;
  showSelect?: boolean;
  showCancel?: boolean;
  showNow?: boolean;
  showPreview?: boolean;
};

const props = defineProps<{
  locale?: Locale;
  actionRow?: ActionRowConfig;
}>();

const i18n = useI18n();

const effectiveLocale = computed<Locale>(() => {
  if (props.locale) return props.locale;
  switch (i18n.locale.value) {
    case 'de': return de;
    case 'fr': return fr;
    default: return enUS;
  }
});

const effectiveActionRow = computed<ActionRowConfig>(() => ({
  selectBtnLabel: i18n.t('action.select'),
  cancelBtnLabel: i18n.t('action.cancel'),
  ...props.actionRow,
}));

const picker = ref<{ focus?: () => void; openMenu?: () => void; closeMenu?: () => void } | null>(null);

defineExpose({
  focus: () => picker.value?.focus?.(),
  openMenu: () => picker.value?.openMenu?.(),
  closeMenu: () => picker.value?.closeMenu?.(),
});
</script>
